// extracted by mini-css-extract-plugin
export default {"main":"PrivacyPolicyPage_main__6LS4f","root":"PrivacyPolicyPage_root__Yn6zx","tabs":"PrivacyPolicyPage_tabs__eTzX1","tab":"PrivacyPolicyPage_tab__41ASs"};